import { PageEvent } from '@angular/material/paginator';
import { Guid } from 'guid-typescript';
import { BehaviorSubject } from 'rxjs';
import { OrganizationType } from 'src/app/shared/enums/organization-type.enum';

export interface Department {
  id: number;
  organizationId: number;
  deleted: boolean;
  name: string;
  organizationName: string;
  idToken: string;
  address: string;
  darId: Guid;
  isHeadquarter: boolean;
  invoicingAccountNumber?: number;
  departmentGroupId?: number;
  locationCount: number;
  idTagCount: number;
  departmentGroupName?: string;
  departmentId: number;
  departmentName: string;
  agreementNumber?: number | null;
  highlight?: BehaviorSubject<boolean>;
}
export class DepartmentSearchEvent {
  organizationId?: number;
  query?: string | null;
  paging: PageEvent = new PageEvent();

  constructor(options?: { organizationId?: number; query?: string; paging?: PageEvent }) {
    this.organizationId = options?.organizationId;
    this.query = options?.query;
    if (options?.paging) this.paging = options.paging;
  }
}

export interface UpdateDepartmentAddress {
  fullAddress: string;
  darId: string;
}

export interface CreateDepartmentRequest {
  name: string;
  invoicingAccount?: number | null;
  address?: string | null;
  darId?: string | null;
  departmentGroupId?: number | null;
  isHeadquarter: boolean;
  agreementNumber?: number | null;
}

export interface UpdateDepartmentRequest {
  name: string;
  invoicingAccount?: number | null;
  address?: string | null;
  darId?: string | null;
  departmentGroupId?: number | null;
  isHeadquarter: boolean;
  agreementNumber?: number | null;
}

export interface DepartmentCreated {
  organizationId: number;
  departmentId: number;
}

export interface DepartmentUpdated {
  organizationId: number;
  departmentId: number;
}
export interface CreateDepartmentDialogData {
  organizationId: number;
  departmentId?: number;
  organizationName: string;
  organizationType: OrganizationType;
}

export interface UpdateDepartmentDialogData {
  departmentId: number;
  organizationId: number;
}
